// `video.voice_swap`: a video's speech in another voice (#223).
// A step of the Advanced Talking Head's run, which starts it; live lists no such job, and a
// Studio draft never holds one.
import { VideoVoiceSwapQuote, VideoVoiceSwapRequest } from "../../../api/generated/zod";
import type { JobTypeModule } from "./contract";

export const jobType: JobTypeModule<"video.voice_swap"> = {
  type: "video.voice_swap",
  label: "Voice swap",
  source: "form",
  pair: "video.voice_swap",
  fields: () => ({}),
  request: VideoVoiceSwapRequest,
  quote: VideoVoiceSwapQuote,
};
